import { styled } from '../../theme';
import { CoverSection, CoverSectionProps } from '../CoverSection';

export type StoreCoverProps = CoverSectionProps;

export const StoreCover = styled(CoverSection).attrs((props) => ({
	...props,
	withOverlayColor: true,
}))``;
